var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95365 11.6463L5.8072 11.4999H5.60009H3.2001C2.59258 11.4999 2.1001 11.0074 2.1001 10.3999V3.9999C2.1001 3.39239 2.59258 2.8999 3.2001 2.8999H12.8001C13.4076 2.8999 13.9001 3.39239 13.9001 3.9999V10.3999C13.9001 11.0074 13.4076 11.4999 12.8001 11.4999H10.4001H10.193L10.0465 11.6463L8.00009 13.6928L5.95365 11.6463ZM4.8001 4.2999C4.08213 4.2999 3.5001 4.88193 3.5001 5.5999C3.5001 6.31787 4.08213 6.8999 4.8001 6.8999H11.2001C11.9181 6.8999 12.5001 6.31787 12.5001 5.5999C12.5001 4.88193 11.9181 4.2999 11.2001 4.2999H4.8001ZM4.8001 7.4999C4.08213 7.4999 3.5001 8.08193 3.5001 8.7999C3.5001 9.51787 4.08213 10.0999 4.8001 10.0999H7.20009C7.91806 10.0999 8.50009 9.51787 8.50009 8.7999C8.50009 8.08193 7.91806 7.4999 7.20009 7.4999H4.8001Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.dda8d78d0936bda8287415e161879287.svg";
export { ForwardRef as ReactComponent };